import type { LocationQuery } from 'vue-router';

export const QUERY_PARAM_FEATURE_KEY = 'feature';

export enum QueryParamFeatures {
  ABANDONMENT_MODAL = 'abandonment-modal',
}

export const isQueryParamFeatureEnabled = (
  feature: QueryParamFeatures,
  query: LocationQuery,
): boolean => query[QUERY_PARAM_FEATURE_KEY] === feature;
